module.exports = __webpack_public_path__ + "static/img/icon_completed.1ce6b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_completed.png
// module id = 18dg
// module chunks = 96